import React from 'react';
export function Header() {
  return <header className="sticky top-0 z-50 bg-blue-600 text-white py-3 px-4" data-id="element-75">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-center items-center" data-id="element-76">
        <div className="text-center font-medium mb-2 md:mb-0" data-id="element-77">
          Limited time sale! Buy 2 Get 1 Free Sale now live.
        </div>
        <a href="https://seravaco.shop/products/glucora%E2%84%A2-metaboshield%E2%84%A2?variant=47313966498019" className="bg-white text-blue-600 hover:bg-blue-50 transition-colors font-semibold py-1.5 px-5 rounded ml-0 md:ml-6" data-id="element-78">
          Shop Now
        </a>
      </div>
    </header>;
}